import { render, staticRenderFns } from "./Ticket-Closer-Detail.vue?vue&type=template&id=2758ffd8"
import script from "./Ticket-Closer-Detail.vue?vue&type=script&lang=js"
export * from "./Ticket-Closer-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports